// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"8a82befa","157":"4e3d91c0","167":"873080f5","177":"b5ddc643","229":"913044ce","328":"fa811570","419":"254f307d","433":"c1394a9f","511":"ea3a310f","520":"0fb20a8e","573":"adbceb77","757":"ccccccef","778":"a1a8a1b1","955":"bdb23112"}[chunkId] + ".chunk.js";
};